import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface SompoTitleProps {
    name: string;
}

const SompoTitle = (props: SompoTitleProps) => (
    <Box
        sx={{
            display: "flex",
            alignItems: "center",
        }}
    >
        <Typography
            variant="h1"
            sx={{
                display: "flex",
                alignItems: "center",
                wordBreak: "break-all",
            }}
        >
            {props.name}
        </Typography>
    </Box>
);

export default SompoTitle;
